<div class="container-fluid-modal">
 <form #cat="ngForm" (ngSubmit)="cat.form.valid && submitForm(cat.value)" novalidate>

    <div *ngIf="formShow === 'add'" class="add">
      <div class="ModalHeader">
        <h4 mat-dialog-title>Add Report</h4>
        <div class="headerButton">
          <button [disabled]="" class="btn btn-success" type="submit"><i aria-hidden="true" class="fa fa-floppy-o"></i>
            Save
          </button>
          <button (click)="close()" class="btn btn-warning" matDialogClose type="button"><i
            aria-hidden="true" class="fa fa-times"></i> Close
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <div class="card">
          <div class="card-body">

            <div class="form-group col-lg-12">
              <label class="labelRequired">Report Name </label>
              <input [(ngModel)]="formData.report_name" class="form-control" name="report_name"
              #report_name="ngModel"required  placeholder="Report Name" required type="text"[ngClass]= "{'has-danger': cat?.submitted  && report_name?.invalid }">
               <div *ngIf="cat?.submitted  && report_name?.invalid ">
                <div [hidden]="!report_name.errors.required" class="formError"> * Report Name is required </div>
               </div>
             </div>

            <div class="form-group col-lg-12">
              <label class="labelRequired">Report Type </label>
                <input [(ngModel)]="formData.report_type" class="form-control" name="report_type"
              #report_type="ngModel"required  placeholder="Report Type" required type="text"[ngClass]= "{'has-danger': cat?.submitted  && report_type?.invalid }">
               <div *ngIf="cat?.submitted  && report_type?.invalid ">
                <div [hidden]="!report_type.errors.required" class="formError"> * Report Type is required </div>
               </div>
             </div>
            
           </div>
          </div>
      </mat-dialog-content>
    </div>

    <div *ngIf="formShow === 'edit'" class="edit">
      <div class="ModalHeader">
        <h4 mat-dialog-title>Edit Report</h4>
        <div class="headerButton">
          <button *ngIf="editPermission" class="btn btn-success" type="submit"><i aria-hidden="true" class="fa fa-floppy-o"></i> Save
          </button>
          <button (click)="close()" class="btn btn-warning" matDialogClose type="button"><i
            aria-hidden="true" class="fa fa-times"></i> Cancel
          </button>
        </div>
       </div>

      <mat-dialog-content>
        <div class="card">
          <div class="card-body">
       
          <div class="form-group col-lg-12"> 
              <label class="labelRequired">Report Name </label>
              <input [(ngModel)]="editData.report.name" class="form-control" name="report_name"
                     placeholder="Report Name" required #report_name="ngModel" type="text"[ngClass]= "{'has-danger': cat?.submitted  && report_name?.invalid }">
               <div *ngIf="cat?.submitted  && report_name?.invalid ">
                <div [hidden]="!report_name.errors.required" class="formError"> * Report Name is required </div>
               </div>
           </div>

            <div class="form-group col-lg-12">
              <label class="labelRequired">Report Type </label>
              <input class="form-control" name="report_type" [(ngModel)]="editData.report.type" placeholder="Report Type"#report_type="ngModel"required type="text"[ngClass]= "{'has-danger': cat?.submitted  && report_type?.invalid }">
               <div *ngIf="cat?.submitted  && report_type?.invalid ">
                <div [hidden]="!report_type.errors.required" class="formError"> * Report Type is required </div>
               </div>
            </div>
                   
          </div>
        </div>
      </mat-dialog-content>
    </div>
  </form>
</div>
